<!--suppress JSNonASCIINames -->
<template>
  <div>
    <!-- search -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          :key="`search-${index}`"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
          @select="onSearchInput(component['value'], index, $event)"
        />
      </div>
    </search-nav>

    <!-- list -->
    <div>
      <fragment v-if="mode === 'popup'">
        <div class="w-full flex">
          <div class="flex mr-auto mb-4">
            <vs-button type="border" color="secondary" @click="onClickRefresh" class="mr-4">
              <div class="flex gap-2 justify-center items-center">
                <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
                새로고침
              </div>
            </vs-button>
            <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px">
              <vs-select-item v-for="v in [10, 20, 30, 50]" :key="`per-${v}`" :text="`${v}개씩 보기`" :value="v" />
            </vs-select>
          </div>
        </div>
      </fragment>

      <fragment v-else>
        <div class="w-full grid md:flex flex-wrap gap-2 mb-4">
          <div class="pl-2 xl:pl-0 hidden md:flex items-center" style="font-size: 18px">
            <span class="mr-2" style="font-weight: 700">전체 건수 : </span>
            <span>{{ new Intl.NumberFormat().format(filteredPostList.length) }}건</span>
            <span v-if="allPostList.length > 0" class="ml-2">{{ 카운트표시 }}</span>
            <span v-if="isLoadingChunks" class="ml-4 text-sm" style="color: #999"> (데이터 로딩 중... {{ loadingProgress }}%) </span>
          </div>
          <vs-button v-if="checkList.length > 0 && enabledDeleteButton" color="secondary" type="border" :class="[checkList.length > 0 && enabledDeleteButton && 'md:ml-auto']" @click="onClickDeleteSelectAll">
            <div class="flex gap-2 justify-center items-center">
              <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
              선택삭제
            </div>
          </vs-button>
          <vs-button :class="[(checkList.length === 0 || !enabledDeleteButton) && 'md:ml-auto']" color="secondary" type="border" :disabled="isLoadingChunks" @click="onClickExcelDownload">
            엑셀 다운로드{{ isLoadingChunks ? " (로딩 중)" : "" }}
          </vs-button>
          <vs-button
            v-if="enabledEditButton || enabledDeleteButton"
            color="secondary"
            type="border"
            @click="
              isEditMode = !isEditMode;
              editIndex = -1;
            "
            >{{ isEditMode ? "닫기" : "편집" }}</vs-button
          >
          <vs-button v-if="enabledCreateButton" color="secondary" @click="showPopup = true">신규등록</vs-button>
        </div>
        <div class="flex mb-4">
          <div class="mr-auto pl-2 xl:pl-0 md:hidden flex items-center" style="font-size: 18px">
            <span class="mr-2" style="font-weight: 700">전체 건수 : </span>
            <span>{{ filteredPostList.length }}건</span>
            <span v-if="allPostList.length > 0" class="ml-2">{{ 카운트표시 }}</span>
          </div>

          <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px" @change="onChangePerPage">
            <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" :key="`per-${v}`" />
          </vs-select>
        </div>
      </fragment>

      <div class="w-full overflow-x-auto">
        <div class="list" :class="{ update: isEditMode, 'hide-revision': !use개정 }">
          <div class="list-header list-grid">
            <div class="list-edit">
              <vs-checkbox :value="allCheck" @input="onClickPaginationListAllCheck" />
            </div>
            <div>No.</div>
            <div>연도</div>
            <div>사업장명</div>
            <div>팀명</div>
            <div>공장명</div>
            <div>대분류</div>
            <div>중분류</div>
            <div>소분류</div>
            <div>위험성평가 실시 여부</div>
            <div v-if="use개정">개정</div>
            <div class="list-edit">수정/삭제</div>
          </div>
          <div class="list-body">
            <div
              v-for="(data, index) in paginationList"
              :key="index"
              class="list-grid"
              :class="{
                active: mode === 'popup' && data.id === selectData.id,
                'cursor-pointer': mode === 'popup' || (mode === 'list' && riskAssessmentMap.get(data.id)),
                'cursor-not-allowed': mode === 'popup' && (get실시여부(data) === '실시완료' || get실시여부(data) === '결재중'),
                editing: editIndex === index,
              }"
              @click="onClickItem(data)"
            >
              <template v-if="editIndex !== index">
                <div class="list-edit">
                  <vs-checkbox :value="checkList.includes(data.id)" @input="checkList.includes(data.id) ? checkList.remove(data.id) : checkList.push(data.id)" />
                </div>
                <div>{{ getRowNumber(index) }}</div>
                <div>{{ getYear() }}</div>
                <div>{{ data.body.사업장 ? data.body.사업장.field_name : "" }}</div>
                <div>{{ data.body.팀명 }}</div>
                <div>{{ data.body.공장명 }}</div>
                <div>{{ data.body.대분류 }}</div>
                <div>{{ data.body.중분류 }}</div>
                <div>{{ data.body.소분류 }}</div>
                <div>
                  <span v-if="get실시여부(data) === '결재중'">결재중</span>
                  <span v-else-if="get실시여부(data) === '실시완료'">실시완료</span>
                  <span v-else-if="get실시여부(data) === '개정필요'" style="color: #ea5455">개정필요</span>
                  <span v-else style="color: #ea5455">미실시</span>
                </div>
                <div v-if="use개정" class="flex justify-center items-center">
                  <vs-button
                    :disabled="!enabled개정(data)"
                    class="h-min whitespace-no-wrap border-none"
                    :color="!enabled개정(data) ? '#E9E9E9' : 'secondary'"
                    :text-color="!enabled개정(data) ? '#aaaaaa' : '#fff'"
                    @click.stop="onClickCopysave(data)"
                    >개정</vs-button
                  >
                </div>
                <div class="list-edit">
                  <!-- 편집 / 삭제 -->
                  <div class="flex justify-center gap-3">
                    <button v-if="enabledEditButton" class="p-2" @click.stop.prevent="onClickEdit(index)">
                      <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                    </button>
                    <button v-if="enabledDeleteButton" class="p-2" @click.stop.prevent="onClickDelete(index)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                    </button>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="list-edit">
                  <vs-checkbox :value="checkList.includes(data.id)" @input="checkList.includes(data.id) ? checkList.remove(data.id) : checkList.push(data.id)" />
                </div>
                <div>{{ getRowNumber(index) }}</div>
                <div>
                  <ml-input v-model="editData.header.year" type="number" />
                </div>
                <div>
                  <field-selector
                    v-model="editData.body.사업장.id"
                    @select="
                      (field) => {
                        editData.body.사업장.field_name = field.field_name;
                      }
                    "
                  />
                </div>
                <div><ml-input v-model="editData.body.팀명" /></div>
                <div><ml-input v-model="editData.body.공장명" /></div>
                <div><ml-input v-model="editData.body.대분류" /></div>
                <div><ml-input v-model="editData.body.중분류" /></div>
                <div><ml-input v-model="editData.body.소분류" /></div>
                <div>
                  <span v-if="get실시여부(data) === '결재중'">결재중</span>
                  <span v-else-if="get실시여부(data) === '실시완료'">실시완료</span>
                  <span v-else-if="get실시여부(data) === '개정필요'" style="color: #ea5455">개정필요</span>
                  <span v-else style="color: #ea5455">미실시</span>
                </div>
                <div class="list-edit">
                  <!-- 완료 / 닫기 -->
                  <div class="flex justify-center gap-3">
                    <button class="p-2" @click="onClickEditSave">
                      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                    </button>
                    <button class="p-2" @click="onClickEditClose">
                      <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                    </button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 0" v-model="page"></k-pagination>
        </div>
      </div>
    </div>

    <div v-if="mode === 'popup'" class="flex justify-end gap-4">
      <vs-button color="#DCDFE2" text-color="black" @click="$emit('close')">닫기</vs-button>
      <vs-button color="secondary" @click="$emit('select', selectData)">등록</vs-button>
    </div>

    <!-- write -->
    <popup-create736 v-if="enabledCreateButton" v-model="showPopup" :board="board" :header="header" @save="onClickPopupSave" />
    <popup-excel-download v-model="openExcelDownloadPopup" :list="excelList" title="공전분류표(직영)" />
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import PopupCreate736 from "@/views/boards/single-page/736/PopupCreate736.vue";
import List from "./List.js";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    PopupExcelDownload,
    KPagination,
    PopupCreate736,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    permission: Object,
    mode: {
      type: String,
      default: "list",
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return 736;
    },
    allCheck() {
      return this.paginationList.length === this.paginationList.filter((data) => this.checkList.includes(data.id)).length;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    stdSearchComponents() {
      const getComponents = List.components;
      if (getComponents) {
        const stdSearchComponents = getComponents();
        if (stdSearchComponents && stdSearchComponents.length > 0) {
          for (const component of stdSearchComponents) {
            component.component = searchComponent[component["component"]];
            if (component.value === "사업장") {
              // nav.options.사업장에 이미 "전체"가 포함되어 있으므로 그대로 사용
              component.options.items = this.nav.options.사업장;
              component.options.disabled = false;
            } else if (component.value === "팀명") {
              component.options.items = this.nav.options.팀명;
              component.options.disabled = false; // 항상 활성화
            } else if (component.value === "공장명") {
              component.options.items = this.nav.options.공장명;
              component.options.disabled = false; // 항상 활성화
            } else if (component.value === "대분류") {
              component.options.items = this.nav.options.대분류;
              component.options.disabled = false; // 항상 활성화
            } else if (component.value === "중분류") {
              component.options.items = this.nav.options.중분류;
              component.options.disabled = false; // 항상 활성화
            } else if (component.value === "소분류") {
              component.options.items = this.nav.options.소분류;
              component.options.disabled = false; // 항상 활성화
            }
          }
        }
        return stdSearchComponents;
      }
      return [];
    },
    // 엑셀 다운로드를 위한 데이터
    excelList() {
      return this.filteredPostList.map((data) => {
        const header = data.header;
        const body = data.body;
        return {
          // 연도: header ? header.year : new Date().getFullYear(),
          연도: this.getYear(), // header ? header.year : new Date().getFullYear(),
          사업장명: body.사업장 ? body.사업장.field_name : "",
          팀명: body.팀명,
          공장명: body.공장명,
          대분류: body.대분류,
          중분류: body.중분류,
          소분류: body.소분류,
          위험성평가실시여부: this.get실시여부(data),
        };
      });
    },
    enabledEditButton() {
      if (this.permission) {
        return this.permission.u;
      }
      return false;
    },
    enabledCreateButton() {
      if (this.permission) {
        return this.permission.c;
      }
      return false;
    },
    enabledDeleteButton() {
      if (this.permission) {
        return this.permission.d;
      }
      return false;
    },
    // 필터링된 전체 리스트
    filteredPostList() {
      if (!this.allPostList || this.allPostList.length === 0) {
        return [];
      }

      let filtered = [...this.allPostList];

      // 연도 필터 - 숫자로 변환
      const 연도필터 = Number(this.nav.value.year) || null;
      if (연도필터) {
        filtered = filtered.filter((data) => {
          if (!data.created_at) return false;
          const createdYear = new Date(data.created_at).getFullYear();
          return createdYear <= 연도필터;
        });
      }

      // deleted_year 필터 추가
      filtered = filtered.filter((data) => {
        if (data.body && data.body.deleted_year) {
          const deletedYear = Number(data.body.deleted_year);
          // 선택된 연도가 deleted_year보다 작으면 표시 (선택된 연도 >= deleted_year이면 숨김)
          return 연도필터 < deletedYear;
        }
        return true; // deleted_year가 없으면 항상 표시
      });

      // 사업장 필터
      const 사업장 = this.nav.value.사업장;
      if (사업장 && 사업장 !== "전체") {
        filtered = filtered.filter((data) => (data.body.사업장 ? data.body.사업장.field_name : "") === 사업장);
      }

      // 팀명 필터
      const 팀명 = this.nav.value.팀명;
      if (팀명 && 팀명 !== "전체") {
        filtered = filtered.filter((data) => (data.body.팀명 ? data.body.팀명 : "") === 팀명);
      }

      // 공장명 필터
      const 공장명 = this.nav.value.공장명;
      if (공장명 && 공장명 !== "전체") {
        filtered = filtered.filter((data) => (data.body.공장명 ? data.body.공장명 : "") === 공장명);
      }

      // 대분류 필터
      const 대분류 = this.nav.value.대분류;
      if (대분류 && 대분류 !== "전체") {
        filtered = filtered.filter((data) => (data.body.대분류 ? data.body.대분류 : "") === 대분류);
      }

      // 중분류 필터
      const 중분류 = this.nav.value.중분류;
      if (중분류 && 중분류 !== "전체") {
        filtered = filtered.filter((data) => (data.body.중분류 ? data.body.중분류 : "") === 중분류);
      }

      // 소분류 필터
      const 소분류 = this.nav.value.소분류;
      if (소분류 && 소분류 !== "전체") {
        filtered = filtered.filter((data) => (data.body.소분류 ? data.body.소분류 : "") === 소분류);
      }

      // 실시여부 필터
      const 실시여부필터 = this.nav.value.실시여부;
      if (실시여부필터 && 실시여부필터 !== "") {
        filtered = filtered.filter((data) => {
          const 실시여부 = this.get실시여부(data);
          return 실시여부 === 실시여부필터;
        });
      }

      return filtered;
    },

    // 현재 페이지에 표시할 데이터
    paginationList() {
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredPostList.slice(start, end);
    },

    // 실시여부별 카운트
    실시여부카운트() {
      // 항상 filteredPostList를 기준으로 카운트
      const counts = {
        전체: this.filteredPostList.length,
        미실시: 0,
        결재중: 0,
        실시완료: 0,
        개정필요: 0,
      };

      this.filteredPostList.forEach((data) => {
        const 실시여부 = this.get실시여부(data);
        if (counts[실시여부] !== undefined) {
          counts[실시여부]++;
        }
      });

      return counts;
    },

    // 표시용 카운트 문자열 (천 단위 쉼표 포함)
    카운트표시() {
      const counts = this.실시여부카운트;
      const format = (num) => new Intl.NumberFormat().format(num);
      const parts = [`미실시: ${format(counts.미실시)}건`, `결재중: ${format(counts.결재중)}건`, `실시완료: ${format(counts.실시완료)}건`, `개정필요: ${format(counts.개정필요)}건`];
      return `(${parts.join(", ")})`;
    },

    // 로딩 진행률
    loadingProgress() {
      if (this.totalChunks === 0) return 0;
      return Math.round((this.currentChunk / this.totalChunks) * 100);
    },

    use개정() {
      // 편집모드일 때는 컬럼 숨김
      if (this.isEditMode) return false;

      // 팝업 모드일 때는 컬럼 숨김
      if (this.mode === "popup") return false;

      // 항상 컬럼 표시 (버튼 활성화는 enabled개정에서 처리)
      return true;
    },
  },
  watch: {
    page() {
      // 페이지 변경 시 URL만 업데이트 (데이터 재로드 불필요)
      this.$nextTick(() => {
        this.updateQueryString();
      });
    },
    filteredPostList() {
      // 필터링된 결과에 따라 페이지네이션 정보 업데이트
      const filteredTotal = this.filteredPostList.length;
      const newLastPage = Math.ceil(filteredTotal / this.perPage);

      // lastPage가 실제로 변경된 경우에만 업데이트
      if (this.lastPage !== newLastPage) {
        this.lastPage = newLastPage;
      }

      // 현재 페이지가 범위를 벗어나면 첫 페이지로 (무한 루프 방지)
      if (this.page > this.lastPage && this.lastPage > 0 && this.page !== 1) {
        this.$nextTick(() => {
          this.page = 1;
        });
      }
    },
    "nav.value.대분류": {
      handler() {
        this.nav.value.중분류 = "전체";
        this.nav.value.소분류 = "전체";
      },
      deep: true,
    },
    "nav.value.중분류": {
      handler() {
        this.nav.value.소분류 = "전체";
      },
      deep: true,
    },
  },
  data() {
    return {
      firstLoad: false, //첫번째 호출인지 판단하기 위함
      nav: {
        value: {},
        options: {
          사업장: [],
          팀명: [],
          공장명: [],
          대분류: [],
          중분류: [],
          소분류: [],
        },
      },
      showPopup: false,
      isEditMode: false, // 편집모드 상태인지
      askForDelete: true, // 삭제 확인창
      selectData: {
        id: 0,
      }, // 선택한 데이터 (popup 모드일 때 사용가능)

      editIndex: -1, // 수정중인 인덱스
      editData: {}, // 수정중인 데이터

      page: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
      searchedList: [],
      allList: [], // 전체 리스트 (구버전)
      checkList: [],

      // 전체 736 데이터 (청킹으로 누적)
      allPostList: [],

      // 청킹 관련
      CHUNK_SIZE: 500,
      isLoadingChunks: false,
      cancelChunkLoading: false,
      currentChunk: 0,
      totalChunks: 0,
      isLoadingMain: false, // 메인 로딩 중 플래그 추가

      form: {
        사업장: {},
        팀명: "",
        공장명: "",
        대분류: "",
        중분류: "",
        소분류: "",
      },
      search: {},
      openExcelDownloadPopup: false,

      // 현재 목록에 대한 위험성평가 목록 (구버전 - 제거 예정)
      riskAssessment: [],

      // 813 게시판 위험성평가 데이터 (has-value API 결과)
      // key: "팀명|공장명|대분류|중분류|소분류", value: API 응답 객체
      riskAssessmentMap: new Map(),
    };
  },
  created() {
    this.firstLoad = true;

    // nav.value 초기화 - Vue 반응성 보장
    const query = this.$route.query;

    // 연도 초기화 (URL 쿼리 파라미터 또는 현재 연도)
    const yearFromQuery = query.y ? Number(query.y) : null;
    this.$set(this.nav.value, "year", yearFromQuery || new Date().getFullYear());

    // 기타 필터 초기화 (URL 쿼리 파라미터에서 읽기)
    this.$set(this.nav.value, "사업장", query.s0 || "전체");
    this.$set(this.nav.value, "팀명", query.s1 || "전체");
    this.$set(this.nav.value, "공장명", query.s2 || "전체");
    this.$set(this.nav.value, "대분류", query.s3 || "전체");
    this.$set(this.nav.value, "중분류", query.s4 || "전체");
    this.$set(this.nav.value, "소분류", query.s5 || "전체");
    this.$set(this.nav.value, "실시여부", query.risk || "");

    if (query.pp) this.perPage = Number(query.pp) || 10;
    this.$nextTick();
    if (query.pg) this.page = Number(query.pg) || 1;

    // popup 모드가 아닐 때만 자동 로딩 (popup 모드는 팝업이 열릴 때 수동으로 로딩)
    if (this.mode !== "popup") {
      this.loadPostListInPage();
    }
  },
  mounted() {
    this.firstLoad = false;
  },
  methods: {
    getYear() {
      // 필터에서 선택된 연도 반환
      return this.nav.value.year || new Date().getFullYear();
    },
    onClickRefresh() {
      // 팝업 모드에서 데이터 새로고침
      this.loadPostListInPage();
    },
    async onClickCopysave(data) {
      try {
        const projectId = this.projectId;
        const boardSlug = "board-813";
        const key = this.getRiskAssessmentKey(data);
        const riskData = this.riskAssessmentMap.get(key);

        let form = {};

        if (riskData && riskData.id) {
          // 케이스 1: riskData 있음 - 기존 위험성평가 복사

          // 위험성평가 상세 데이터 불러오기
          const response = await this.$store.dispatch("approval/LOAD_POST", { boardSlug, postId: riskData.id });
          form = JSON.parse(response.post.post_content);

          // 작성자 정보 업데이트
          form.body.stdInfo.department = this.myInfo.department;
          form.body.stdInfo.section = this.myInfo.section;
          form.body.stdInfo.rank = this.myInfo.rank;
          form.body.stdInfo.writer_name = this.myInfo.name;
          form.body.stdInfo.date = new Date().format("yyyy-MM-dd");

          // 헤더 정보 업데이트
          const year = new Date().getFullYear();
          const month = new Date().getMonth() + 1;
          const date = new Date().format("yyyy-MM-dd");
          const half = month <= 6 ? "상반기" : "하반기";
          const quarter = month <= 3 ? "1" : month <= 6 ? "2" : month <= 9 ? "3" : "4";
          form.header = {
            year,
            month,
            date,
            half,
            quarter,
            full: date,
          };

          // 개정 시 평가일자를 오늘 날짜로 변경 (813 개정 버튼과 동일)
          if (!form.body.위험성평가정보) form.body.위험성평가정보 = {};
          form.body.위험성평가정보.평가일자 = date;
        } else {
          // 케이스 2: riskData 없음 - 새 위험성평가 생성

          const year = new Date().getFullYear();
          const month = new Date().getMonth() + 1;
          const date = new Date().format("yyyy-MM-dd");
          const half = month <= 6 ? "상반기" : "하반기";
          const quarter = month <= 3 ? "1" : month <= 6 ? "2" : month <= 9 ? "3" : "4";

          form = {
            header: {
              year,
              month,
              date,
              half,
              quarter,
              full: date,
            },
            body: {
              stdInfo: {
                field_id: data.body.사업장.id,
                field_name: data.body.사업장.field_name,
                department: this.myInfo.department,
                section: this.myInfo.section,
                com_name: "",
                rank: this.myInfo.rank,
                writer_name: this.myInfo.name,
                date,
              },
              fileList: [],
              위험성평가구분: "",
              위험성평가정보: {
                평가일자: date,
                공장: data.body.공장명 || "",
                팀: data.body.팀명 || "",
                공정: data.body.소분류 || "",
              },
              공정분류: {
                대분류: data.body.대분류 || "",
                중분류: data.body.중분류 || "",
                소분류: data.body.소분류 || "",
                구분: "",
                구분_수시: "",
                아차사고: "",
                raw: {
                  id: data.id,
                  사업장: {
                    id: data.body.사업장.id,
                    field_name: data.body.사업장.field_name,
                  },
                  팀명: data.body.팀명 || "",
                  공장명: data.body.공장명 || "",
                  대분류: data.body.대분류 || "",
                  중분류: data.body.중분류 || "",
                  소분류: data.body.소분류 || "",
                },
              },
              아차사고: [],
              아차사고_개정: [],
              작업빈도: { 일: 0, 주: 0, 월: 0, 분기: 0, 년: 0, 회당작업시간: 0 },
              sign: {
                작성자: { name: "", sign: "" },
                검토자: { name: "", sign: "" },
              },
              동일직무인원: { 상주반: 0, 교대반: 0 },
              위험성평가표: {
                위험도: "",
                중요위험: "N",
                data: [],
                안전보호구: "",
                정리정돈사항: "",
                ONEPOINT: "",
              },
              개선내역: [],
              공정명비활성화여부: false,
            },
          };
        }

        await this.createApprovalPost(projectId, boardSlug, form);
      } catch (e) {
        console.error("[736 개정 버튼] 오류:", e);
        alert(`오류가 발생했습니다: ${e.message}`);
      }
    },
    async createApprovalPost(projectId, boardSlug, form) {
      const title = "공정분류표(직영)";
      const content = JSON.stringify(form);
      const result = await this.$store
        .dispatch("approval/CREATE_POST", {
          isTemp: 1,
          boardSlug,
          parentId: this.parentId,
          projectId,
          title,
          content,
          security: "normal",
          priority: "medium",
        })
        .catch((error) => {
          this.customAlert(error.response.data);
          return false;
        });
      if (result === false) return;
      alert("임시저장 되었습니다");
      const route = this.$router.resolve({
        name: "write|update|tab",
        params: {
          pageType: "write",
          proj_id: projectId,
          boardId: 813,
          postId: result.postId,
        },
      });
      const width = screen.availWidth;
      const height = screen.availHeight;
      window.open(
        route.href,
        "writePopup",
        `width=${width},
        height=${height},
        left=0,
        top=0,
        resizable=yes,
        scrollbars=yes`
      );
    },

    // 736 게시글 ID를 키로 사용
    getRiskAssessmentKey(data) {
      return data.id;
    },

    // 실시 여부 반환
    get실시여부(data) {
      const key = this.getRiskAssessmentKey(data);
      const riskData = this.riskAssessmentMap.get(key);

      // 선택된 필터 연도 (없으면 현재 연도) - 숫자로 변환
      const selectedYear = Number(this.nav.value.year) || new Date().getFullYear();

      // 736 게시글의 등록 연도
      const 게시글등록연도 = data.created_at ? new Date(data.created_at).getFullYear() : null;

      // 813 문서가 없는 경우
      if (!riskData) {
        // 게시글이 선택된 연도에 등록되었으면 "미실시"
        if (게시글등록연도 === selectedYear) {
          return "미실시";
        }
        // 게시글이 선택된 연도 이전에 등록되었으면 "개정필요"
        if (게시글등록연도 && 게시글등록연도 < selectedYear) {
          return "개정필요";
        }
        return "미실시";
      }

      const statusId = riskData.approval ? riskData.approval.document_status_id : null;
      const approvedAt = riskData.approval ? riskData.approval.approved_at : null;

      // 결재 중 (statusId = 2 또는 3)
      if (statusId === 2 || statusId === 3) return "결재중";

      // 결재 완료 (statusId = 4)
      if (statusId === 4) {
        if (approvedAt) {
          const approvedYear = new Date(approvedAt).getFullYear();

          // 선택된 연도에 승인되었으면 "실시완료"
          if (approvedYear === selectedYear) return "실시완료";

          // 선택된 연도 이전에 승인되었으면 "개정필요"
          if (approvedYear < selectedYear) return "개정필요";
        }
        return "실시완료";
      }

      return "미실시";
    },

    // 개정 버튼 활성화 여부
    enabled개정(data) {
      // 선택된 연도가 현재 연도가 아니면 모든 버튼 비활성화 - 숫자로 변환
      const selectedYear = Number(this.nav.value.year) || new Date().getFullYear();
      const currentYear = new Date().getFullYear();
      if (selectedYear !== currentYear) {
        return false;
      }

      const 실시여부 = this.get실시여부(data);
      // 미실시, 개정필요일 때 활성화
      if (실시여부 === "미실시" || 실시여부 === "개정필요") {
        return true;
      }

      // 실시완료 상태이면서 현재 연도(2026년)인 경우에도 활성화
      if (실시여부 === "실시완료") {
        const key = this.getRiskAssessmentKey(data);
        const riskData = this.riskAssessmentMap.get(key);
        if (riskData && riskData.approval && riskData.approval.approved_at) {
          const approvedYear = new Date(riskData.approval.approved_at).getFullYear();
          return approvedYear === currentYear; // 2026년이면 활성화
        }
      }

      return false;
    },

    // 메모리 데이터에서 필터 옵션 추출 (계층적 필터링)
    extractFilterOptionsFromData() {
      let data = [...this.allPostList];

      // 연도 필터 적용 - 숫자로 변환
      const year = Number(this.nav.value.year) || null;
      if (year) {
        data = data.filter((item) => {
          if (!item.created_at) return false;
          return new Date(item.created_at).getFullYear() <= year;
        });
      }

      const options = {
        사업장: new Set(),
        팀명: new Set(),
        공장명: new Set(),
        대분류: new Set(),
        중분류: new Set(),
        소분류: new Set(),
      };

      // 1. 사업장은 항상 전체 데이터에서 추출 (제한 없음)
      data.forEach((item) => {
        if (item.body.사업장 ? item.body.사업장.field_name : "") options.사업장.add(item.body.사업장.field_name);
      });

      // 2. 팀명: 사업장이 선택되면 해당 사업장 내에서만 추출
      let filteredForTeam = data;
      const 사업장 = this.nav.value.사업장;
      if (사업장 && 사업장 !== "전체") {
        filteredForTeam = data.filter((item) => {
          return item.body.사업장 && item.body.사업장.field_name === 사업장;
        });
      }
      filteredForTeam.forEach((item) => {
        if (item.body.팀명) options.팀명.add(item.body.팀명);
      });

      // 3. 공장명: 팀명이 선택되면 해당 팀명 내에서만 추출
      let filteredForFactory = filteredForTeam;
      const 팀명 = this.nav.value.팀명;
      if (팀명 && 팀명 !== "전체") {
        filteredForFactory = filteredForTeam.filter((item) => item.body.팀명 === 팀명);
      }
      filteredForFactory.forEach((item) => {
        if (item.body.공장명) options.공장명.add(item.body.공장명);
      });

      // 4. 대분류: 공장명이 선택되면 해당 공장명 내에서만 추출
      let filteredForCategory1 = filteredForFactory;
      const 공장명 = this.nav.value.공장명;
      if (공장명 && 공장명 !== "전체") {
        filteredForCategory1 = filteredForFactory.filter((item) => item.body.공장명 === 공장명);
      }
      filteredForCategory1.forEach((item) => {
        if (item.body.대분류) options.대분류.add(item.body.대분류);
      });

      // 5. 중분류: 대분류가 선택되면 해당 대분류 내에서만 추출
      let filteredForCategory2 = filteredForCategory1;
      const 대분류 = this.nav.value.대분류;
      if (대분류 && 대분류 !== "전체") {
        filteredForCategory2 = filteredForCategory1.filter((item) => item.body.대분류 === 대분류);
      }
      filteredForCategory2.forEach((item) => {
        if (item.body.중분류) options.중분류.add(item.body.중분류);
      });

      // 6. 소분류: 중분류가 선택되면 해당 중분류 내에서만 추출
      let filteredForCategory3 = filteredForCategory2;
      const 중분류 = this.nav.value.중분류;
      if (중분류 && 중분류 !== "전체") {
        filteredForCategory3 = filteredForCategory2.filter((item) => item.body.중분류 === 중분류);
      }
      filteredForCategory3.forEach((item) => {
        if (item.body.소분류) options.소분류.add(item.body.소분류);
      });

      // Set을 배열로 변환하고 정렬 ("전체"는 한 번만 추가)
      this.nav.options.사업장 = ["전체", ...Array.from(options.사업장).sort()];
      this.nav.options.팀명 = ["전체", ...Array.from(options.팀명).sort()];
      this.nav.options.공장명 = ["전체", ...Array.from(options.공장명).sort()];
      this.nav.options.대분류 = ["전체", ...Array.from(options.대분류).sort()];
      this.nav.options.중분류 = ["전체", ...Array.from(options.중분류).sort()];
      this.nav.options.소분류 = ["전체", ...Array.from(options.소분류).sort()];
    },

    onChangePerPage() {
      this.page = 1;
      this.loadPostListInPage();
    },
    onClickPaginationListAllCheck(check) {
      const list = JSON.parse(JSON.stringify(this.paginationList));
      list.forEach((data) => {
        data.checked = check;
      });

      if (check) {
        this.checkList.push(...list.map((data) => data.id));
        this.checkList = [...new Set(this.checkList)];
      } else {
        list.forEach((data) => {
          const index = this.checkList.indexOf(data.id);
          if (index > -1) {
            this.checkList.splice(index, 1);
          }
        });
      }
    },
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    /**
     * 736 (공정분류표) 게시글을 조회한다 - 청킹 방식
     */
    async loadPostListInPage() {
      // 이미 메인 로딩 중이면 무시
      if (this.isLoadingMain) {
        return;
      }

      // 메인 로딩 플래그 설정
      this.isLoadingMain = true;
      UiUtil.loading(true);

      // 이미 백그라운드 로딩 중이면 취소 플래그 설정
      if (this.isLoadingChunks) {
        this.cancelChunkLoading = true;
        // 취소 플래그가 적용될 시간을 주기 위해 잠시 대기
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      // 초기화
      this.allPostList = [];
      this.riskAssessmentMap.clear();
      this.currentChunk = 0;
      this.isLoadingChunks = false;
      this.cancelChunkLoading = false;

      const conditions = List.getConditions(this.nav);

      // 실시여부 필터는 제외 (클라이언트 사이드 필터링)
      const serverConditions = conditions.filter((c) => c.key !== "실시여부" && !c.key.includes("risk"));

      try {
        // 첫 번째 청크 로드 (즉시 표시)
        await this.loadChunk(1, serverConditions);
        this.extractFilterOptionsFromData(); // 필터 옵션 추출

        // 전체 페이지 수 계산
        this.totalChunks = Math.ceil(this.total / this.CHUNK_SIZE);

        UiUtil.loading(false);
        this.isLoadingMain = false; // 메인 로딩 완료

        // 나머지 청크를 백그라운드에서 로드
        if (this.totalChunks > 1) {
          this.isLoadingChunks = true;
          this.loadRemainingChunks(serverConditions);
        }
      } catch (error) {
        console.error("데이터 로드 실패:", error);
        UiUtil.loading(false);
        this.isLoadingMain = false; // 에러 시에도 플래그 해제
        this.isLoadingChunks = false;
      }

      // URL 쿼리스트링 업데이트
      this.updateQueryString();
    },

    /**
     * 단일 청크 로드
     */
    async loadChunk(chunkNumber, conditions) {
      const options = {
        projectId: this.projectId,
        boardId: this.boardId,
        page: chunkNumber,
        perPage: this.CHUNK_SIZE,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
        withMeta: true,
        onlyMeta: true,
        withoutRelation: true,
        metaKeys: ["body.사업장.id", "body.사업장.field_name", "body.팀명", "body.공장명", "body.대분류", "body.중분류", "body.소분류", "body.deleted_year", "header.year", "header.month", "created_at"],
      };

      // 736 데이터 조회
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);

      // 첫 청크에서 전체 개수 파악
      if (chunkNumber === 1) {
        this.total = response.total;
        this.lastPage = Math.ceil(response.total / this.perPage); // 실제 표시용 페이지 수
      }

      // 데이터 변환 및 저장
      const chunkData = response.data.map((data) => ({
        id: data.id,
        ...data.postContents,
      }));

      // 중복 제거: 이미 존재하는 ID는 제외
      const existingIds = new Set(this.allPostList.map((item) => item.id));
      const newData = chunkData.filter((item) => !existingIds.has(item.id));
      this.allPostList.push(...newData);
      this.currentChunk = chunkNumber;

      // 이 청크에 대한 813 데이터 조회
      await this.load813DataForChunk(chunkData);

      return response;
    },

    /**
     * 특정 청크에 대한 813 데이터 조회 (736 게시글 ID 기반)
     */
    async load813DataForChunk(chunkData) {
      if (chunkData.length === 0) return;

      // 736 게시글 ID 목록 수집
      const postIds = chunkData.map((data) => data.id).filter((id) => id);

      if (postIds.length === 0) return;

      // 736 게시글 ID로 813 데이터 조회
      const hasValueOptions = ["body.공정분류.raw.id"];
      const hasValueValues = postIds.map((id) => [`${id}`]);

      const hasValueParams = {
        boardId: 813,
        options: hasValueOptions,
        values: hasValueValues,
        withApproval: "true",
        approvalStatusIds: [2, 3, 4],
        fieldId: this.fieldId,
      };

      try {
        const hasValueResponse = await this.$store.dispatch("board/LOAD_POST_HAS_VALUE", hasValueParams);

        if (hasValueResponse && Array.isArray(hasValueResponse)) {
          const selectedYear = this.nav.value.year;

          for (const item of hasValueResponse) {
            // 연도 필터링 추가
            if (selectedYear && item.created_at) {
              const itemYear = new Date(item.created_at).getFullYear();
              if (itemYear > selectedYear) {
                continue; // 선택된 연도보다 이후 데이터는 제외
              }
            }

            const options = item.options || {};
            const 공정분류Id = options["body.공정분류.raw.id"];

            if (공정분류Id) {
              // 736 게시글 ID를 키로 사용 (숫자로 변환하여 저장)
              const numericId = typeof 공정분류Id === "string" ? parseInt(공정분류Id, 10) : 공정분류Id;
              this.riskAssessmentMap.set(numericId, item);
            }
          }
        }
      } catch (error) {
        console.error("813 데이터 조회 실패:", error);
      }
    },

    /**
     * 나머지 청크를 백그라운드에서 로드
     */
    async loadRemainingChunks(conditions) {
      for (let chunkNum = 2; chunkNum <= this.totalChunks; chunkNum++) {
        // 취소 플래그 확인
        if (this.cancelChunkLoading) {
          this.isLoadingChunks = false;
          return;
        }

        try {
          await this.loadChunk(chunkNum, conditions);

          // 카운트 업데이트 (화면에 실시간 반영)
          this.$forceUpdate();
        } catch (error) {
          console.error(`청크 ${chunkNum} 로드 실패:`, error);
          // 계속 진행
        }
      }

      this.isLoadingChunks = false;
      this.extractFilterOptionsFromData(); // 전체 데이터 로드 완료 후 최종 옵션 업데이트
    },

    /**
     * URL 쿼리스트링 업데이트
     */
    updateQueryString() {
      const query = this.$route.query;
      query.pg = this.page;
      query.pp = this.perPage;

      this.stdSearchComponents.map((component) => {
        const value = component.value;
        const keys = Object.keys(component.query);
        const query_value = this.nav.value[value];
        if (keys.length > 0) {
          if (query_value === "전체") {
            delete query[keys[0]];
          } else {
            query[keys[0]] = query_value;
          }
        }
      });

      // 쿼리스트링 생성
      const searchParams = new URLSearchParams(query).toString();
      const newUrl = `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}${window.location.hash}`;

      // 주소창만 변경 (화면 이동 없음)
      window.history.replaceState({}, "", newUrl);
    },

    onClickSearch() {
      // 페이지만 1로 리셋 (이미 allPostList에 데이터가 로드되어 있으므로 API 재호출 불필요)
      this.page = 1;

      // URL 쿼리스트링 업데이트
      this.$nextTick(() => {
        this.updateQueryString();
      });
    },
    onClickEdit(index) {
      this.editIndex = index;
      this.editData = JSON.parse(JSON.stringify(this.paginationList[index]));

      // header 객체가 없는 경우 기본값 설정
      if (!this.editData.header) {
        const now = new Date();
        this.editData.header = {
          year: now.getFullYear(),
          month: now.getMonth() + 1,
          date: now.format("yyyy-MM-dd"),
          half: now.getMonth() + 1 <= 6 ? "상반기" : "하반기",
          quarter: now.getMonth() + 1 <= 3 ? "1" : now.getMonth() + 1 <= 6 ? "2" : now.getMonth() + 1 <= 9 ? "3" : "4",
          full: now.format("yyyy-MM-dd"),
        };
      }

      // header.year가 없는 경우에도 기본값 설정
      if (!this.editData.header.year) {
        this.editData.header.year = new Date().getFullYear();
      }
      if (!this.editData.header.month) {
        this.editData.header.month = new Date().getMonth() + 1;
      }
    },
    async onClickDeleteSelectAll() {
      if (this.checkList.length > 0) {
        const selectedYear = this.nav.value.year || new Date().getFullYear();
        this.customConfirm(`선택한 공정 ${this.checkList.length}개를 ${selectedYear}년도 공정분류표에서 삭제하시겠습니까?`, {
          confirmBtn: "삭제",
          confirmFunction: async () => {
            this.onClickEditClose();
            UiUtil.loading(true);

            // 로딩 타임아웃 설정 (10초)
            const loadingTimeout = setTimeout(() => {
              UiUtil.loading(false);
              this.$toast.open({
                type: "warning",
                message: "작업 시간이 초과되었습니다. 새로고침 후 다시 시도해주세요.",
                position: "bottom-right",
                duration: 5000,
              });
            }, 10000);

            try {
              const selectedYear = this.nav.value.year || new Date().getFullYear();
              for (const postId of this.checkList) {
                // 소프트 삭제: deleted_year 필드 설정
                const postData = this.allPostList.find((p) => p.id === postId);
                if (postData) {
                  const updatedData = JSON.parse(JSON.stringify(postData));
                  delete updatedData.id;
                  if (!updatedData.body) updatedData.body = {};
                  updatedData.body.deleted_year = selectedYear;
                  await this.update(postId, updatedData);
                }
              }

              // 성공 메시지 표시
              this.$toast.open({
                type: "success",
                message: `선택한 공정 ${this.checkList.length}개가 성공적으로 삭제되었습니다.`,
                position: "bottom-right",
                duration: 3000,
              });

              this.checkList = [];
              // 삭제 후 캐시 무효화
              this.invalidateAllCache();
              await this.loadPostListInPage();
            } catch (error) {
              console.error("삭제 중 오류 발생:", error);
              this.$toast.open({
                type: "error",
                message: "공정분류표 삭제 중 오류가 발생했습니다.",
                position: "bottom-right",
                duration: 4000,
              });
            } finally {
              clearTimeout(loadingTimeout);
              UiUtil.loading(false);
            }
          },
          cancelBtn: "취소",
        });
      }
    },
    async onClickDelete(index) {
      if (this.askForDelete) {
        const selectedYear = this.nav.value.year || new Date().getFullYear();
        let title = `사업장명: ${this.paginationList[index].body.사업장.field_name}`;
        title += `<br/>팀명: ${this.paginationList[index].body.팀명}`;
        title += `<br/>공장명: ${this.paginationList[index].body.공장명}`;
        title += `<br/>대분류: ${this.paginationList[index].body.대분류}`;
        title += `<br/>중분류: ${this.paginationList[index].body.중분류}`;
        title += `<br/>소분류: ${this.paginationList[index].body.소분류}`;
        title += `<br/><br/>${selectedYear}년도 공정분류표에서 삭제하시겠습니까?`;
        this.customConfirm(title, {
          confirmBtn: "삭제",
          confirmFunction: async () => {
            try {
              // 소프트 삭제: deleted_year 필드 설정
              const postData = JSON.parse(JSON.stringify(this.paginationList[index]));
              const postId = postData.id;
              delete postData.id;
              if (!postData.body) postData.body = {};
              postData.body.deleted_year = selectedYear;
              await this.update(postId, postData);
              // 성공 메시지 표시
              this.$toast.open({
                type: "success",
                message: "공정분류표가 성공적으로 삭제되었습니다.",
                position: "bottom-right",
                duration: 3000,
              });
              // 삭제 후 캐시 무효화
              this.invalidateAllCache();
              await this.loadPostListInPage();
            } catch (error) {
              console.error("삭제 중 오류 발생:", error);
              this.$toast.open({
                type: "error",
                message: "공정분류표 삭제 중 오류가 발생했습니다.",
                position: "bottom-right",
                duration: 4000,
              });
            }
          },

          cancelBtn: "더 이상 묻지않기",
          cancelFunction: async () => {
            this.askForDelete = false;
            try {
              // 소프트 삭제: deleted_year 필드 설정
              const postData = JSON.parse(JSON.stringify(this.paginationList[index]));
              const postId = postData.id;
              delete postData.id;
              if (!postData.body) postData.body = {};
              postData.body.deleted_year = selectedYear;
              await this.update(postId, postData);
              // 성공 메시지 표시
              this.$toast.open({
                type: "success",
                message: "공정분류표가 성공적으로 삭제되었습니다.",
                position: "bottom-right",
                duration: 3000,
              });
              // 삭제 후 캐시 무효화
              this.invalidateAllCache();
              await this.loadPostListInPage();
            } catch (error) {
              console.error("삭제 중 오류 발생:", error);
              this.$toast.open({
                type: "error",
                message: "공정분류표 삭제 중 오류가 발생했습니다.",
                position: "bottom-right",
                duration: 4000,
              });
            }
          },
        });
      } else {
        const selectedYear = this.nav.value.year || new Date().getFullYear();
        try {
          // 소프트 삭제: deleted_year 필드 설정
          const postData = JSON.parse(JSON.stringify(this.paginationList[index]));
          const postId = postData.id;
          delete postData.id;
          if (!postData.body) postData.body = {};
          postData.body.deleted_year = selectedYear;
          await this.update(postId, postData);
          // 성공 메시지 표시
          this.$toast.open({
            type: "success",
            message: "공정분류표가 성공적으로 삭제되었습니다.",
            position: "bottom-right",
            duration: 3000,
          });
          // 삭제 후 캐시 무효화
          this.invalidateAllCache();
          await this.loadPostListInPage();
        } catch (error) {
          console.error("삭제 중 오류 발생:", error);
          this.$toast.open({
            type: "error",
            message: "공정분류표 삭제 중 오류가 발생했습니다.",
            position: "bottom-right",
            duration: 4000,
          });
        }
      }
    },
    async onClickEditSave() {
      if (!this.editData.body.사업장.id) {
        this.customAlert("사업장을 선택해주세요", "수정");
      } else {
        try {
          const id = this.editData.id;
          const editDataCopy = { ...this.editData };
          delete editDataCopy.id;

          await this.update(id, editDataCopy);

          // 성공 메시지 표시
          this.$toast.open({
            type: "success",
            message: "공정분류표가 성공적으로 수정되었습니다.",
            position: "bottom-right",
            duration: 3000,
          });

          this.editIndex = -1;
          // 목록 새로고침 (캐시 무효화)
          this.invalidateAllCache();
          await this.loadPostListInPage();
        } catch (error) {
          console.error("수정 중 오류 발생:", error);
          this.$toast.open({
            type: "error",
            message: "공정분류표 수정 중 오류가 발생했습니다.",
            position: "bottom-right",
            duration: 4000,
          });
        }
      }
    },
    onClickEditClose() {
      this.editIndex = -1;
    },
    onClickPopupSave() {
      // 신규등록 후 캐시 무효화 및 목록 새로고침
      this.invalidateAllCache();
      this.loadPostListInPage();
    },
    async onClickExcelDownload() {
      // 이미 로드된 filteredPostList를 사용하므로 별도 조회 불필요
      // excelList computed 속성이 filteredPostList 기반으로 데이터 제공
      if (this.isLoadingChunks) return;
      this.openExcelDownloadPopup = true;
    },

    async update(postId, form) {
      const year = form.header && form.header.year ? form.header.year : new Date().getFullYear();
      const month = form.header && form.header.month ? form.header.month : new Date().getMonth() + 1;
      form.header = {
        year,
        month,
        full: `${year}-${month > 9 ? month : `0${month}`}-01`,
      };

      const projectId = this.projectId;
      const boardId = this.boardId;
      const content = JSON.stringify(form);

      await this.$store.dispatch("board/UPDATE_POST", {
        projectId,
        boardId,
        postId,
        content,
      });
    },

    async delete(postId) {
      const boardId = this.boardId;
      await this.$store.dispatch("board/DELETE_POST", { boardId, postId });
    },

    getRowNumber(index) {
      return (this.page - 1) * this.perPage + index + 1;
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title || "공정분류표",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    customConfirm(msg, options) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "공정분류표",
          message: msg,
          useConfirm: true,
          confirmBtn: options.confirmBtn || "확인",
          confirmFunction: options.confirmFunction,
          cancelBtn: options.cancelBtn || "닫기",
          cancelFunction: options.cancelFunction,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickItem(data) {
      // 편집 모드일 때는 클릭 이벤트 무시
      if (this.isEditMode) {
        return;
      }

      const 실시여부 = this.get실시여부(data);
      const riskData = this.riskAssessmentMap.get(data.id);

      if (this.mode === "popup") {
        // 실시완료 또는 결재중이 아닌 경우에만 선택 가능
        if (실시여부 !== "실시완료" && 실시여부 !== "결재중") {
          if (this.selectData === data) {
            this.$emit("select", this.selectData);
          } else {
            this.selectData = data;
          }
        }
      } else if (this.mode === "list") {
        // 813 데이터가 있는 경우에만 클릭하여 열기
        if (riskData && riskData.id) {
          const routeData = this.$router.resolve({
            name: "write|update|tab",
            params: {
              proj_id: this.projectId,
              boardId: 813,
              pageType: "write",
              postId: riskData.id,
            },
          });

          // 새 창으로 열기
          const width = window.innerWidth * 1;
          const height = window.innerHeight * 1;
          const left = window.innerWidth * 0;
          const top = window.innerHeight * 0;

          window.open(routeData.href, "_blank", `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`);
        }
      }
    },

    // 캐시 무효화
    invalidateAllCache() {
      // 위험성평가 Map 초기화
      this.riskAssessmentMap.clear();
    },

    // popupSelect736 에서 사용함
    reset() {
      this.selectData = { id: 0 };
      this.askForDelete = true;
      this.editData = {};
      this.editIndex = -1;
      this.page = 1;
      this.lastPage = 1;
      this.perPage = 10;
      this.total = 0;
      this.allList = [];
      this.paginationList = [];
      // 모든 캐시 초기화
      this.invalidateAllCache();
    },

    // 전체 목록을 다운로드 받기 위해 사용
    async _loadDefragmentation(options, list) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      UiUtil.loading(true, list.length, response.total);

      list.push(...response.data);

      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        await this._loadDefragmentation(options, list);
      }
    },

    /**
     * 헤더 검색 폼의 선택지 옵션이 변경됐을 때 호출됨
     * @param label: this.nav.value 중 해당하는 value 값 (사업장, 팀명, 공장명, 대분류, 중분류, 소분류, 실시여부 )
     * @param index: this.stdSearchComponents 의 index 값
     * @param keyword: 선택된 값
     */
    async onSearchInput(label, index, keyword) {
      if (typeof keyword !== "string") {
        if (keyword.target && keyword.target.value) {
          keyword = keyword.target.value;
        } else {
          keyword = "전체";
        }
      }

      // Vue 반응성을 위해 $set 사용
      this.$set(this.nav.value, label, keyword);

      // 연도 필터 변경 시에만 데이터 재로드
      if (label === "year") {
        await this.loadPostListInPage();
        return; // 연도 변경 시 loadPostListInPage에서 모든 처리를 하므로 여기서 종료
      }

      // 계층적 필터: 상위 분류 변경시 하위 분류는 전체로 변경
      const componentOrder = ["사업장", "팀명", "공장명", "대분류", "중분류", "소분류"];
      const currentIndex = componentOrder.indexOf(label);

      if (currentIndex >= 0) {
        // 현재 선택된 컴포넌트 이후의 컴포넌트를 '전체'로 설정
        for (let i = currentIndex + 1; i < componentOrder.length; i++) {
          this.$set(this.nav.value, componentOrder[i], "전체");
        }

        // 필터 옵션 업데이트 (하위 필터의 선택지를 현재 필터에 맞게 조정)
        this.$nextTick(() => {
          this.extractFilterOptionsFromData();
        });
      }

      // 페이지를 1로 리셋 (즉시 반영)
      if (this.page !== 1) {
        this.page = 1;
      }

      // URL 쿼리스트링 업데이트 (다음 틱에서 실행하여 중복 호출 방지)
      this.$nextTick(() => {
        this.updateQueryString();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;
  background: #fff;

  .list-header {
    font-weight: 700;

    & > div {
      background-color: #f5f5f5;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
  }
  .list-body {
    & > div > div {
      border-bottom: 1px solid #e0e0e0;
    }
    & > div:hover {
      background-color: #f5f5f5;
      color: #000;
      font-weight: bold;
    }
    & > div.editing:hover {
      background-color: transparent;
      color: inherit;
      font-weight: normal;
    }
    & > div.active > div {
      background-color: #7e72f299;
      color: #fff;
    }
    & > div.cursor-not-allowed {
      cursor: not-allowed !important;
      &:hover {
        background-color: #f9f9f9;
        color: #999;
        font-weight: normal;
      }
    }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(8, minmax(140px, 1fr)) 94px;

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  &.update {
    .list-grid {
      grid-template-columns: 60px 60px repeat(8, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }

  &.hide-revision {
    .list-grid {
      grid-template-columns: 60px 60px repeat(7, minmax(140px, 1fr));
    }
    &.update .list-grid {
      grid-template-columns: 60px 60px repeat(8, minmax(140px, 1fr)) 94px;
    }
  }
}
</style>
